import axios from "./../../config/axios";

function all() {
    return axios().get("/sales-scheduling/cast-types");
}

export default {
    all
}